
import TransactionTable from '@/components/TransactionTable.vue'
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
export default {
  components: { TransactionTable },
  name: 'TransactionView',
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters(["file"])
  },
  methods: {
    ...mapMutations(["SET_SHOW_CHAT_DIALOG"]),
    async train() {
      console.log("train");
      // const response = await axios.post('http://localhost:8000/train', JSON.stringify(this.file.content))
      //   .then((response) => {
      //     console.log(response);
      //   }, (error) => {
      //     console.log(error);
      //   });
      // console.log(response);
    },
    showChatDialog() {
      this.SET_SHOW_CHAT_DIALOG(true);
    }

  }
}
